(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[251],{

/***/ "CS9y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vpUC");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;



var ProductSEOLine = function ProductSEOLine(_ref) {
  var title = _ref.title,
      meta = _ref.meta,
      script = _ref.script;
  return __jsx(next_head__WEBPACK_IMPORTED_MODULE_4___default.a, null, __jsx("title", {
    key: "title"
  }, title), meta.map(function (_ref2) {
    var content = _ref2.content,
        key = _ref2.key,
        name = _ref2.name,
        property = _ref2.property;
    return __jsx("meta", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({
      key: key || name || property
    }, property ? {
      property: property
    } : {
      name: name
    }, {
      content: content
    }));
  }), script.map(function (_ref3) {
    var type = _ref3.type,
        innerHTML = _ref3.innerHTML;
    return __jsx("script", {
      key: "product-seo-title-ld-json",
      type: type // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: innerHTML
      }
    });
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (ProductSEOLine);

/***/ })

}]);